import { useEffect } from 'react';
import { connect } from 'react-redux';

import { loadDefaultSwaggerApi, updateSwaggerApiVersion } from '../../redux/swaggerApi/swaggerApiActions';
import { checkPathMatch } from '../../utils/helpers';
import GuideNavigation from './GuideNavigation/GuideNavigation';
import SdkNavigation from './SdkNavigation/SdkNavigation';
import Apis from './Apis';

const mapStateToProps = (state) => ({
  infoApi: state.info.data,
  selectedVersion: state.swaggerApi.selectedVersion,
  activeApi: state.swaggerApi.activeApi,
});

const mapDispatchToProps = {};

const CombinedDocsMenu = (props) => {
  const { routeProps, infoApi, selectedVersion, activeApi } = props;
  const location = routeProps.location;
  const pathName = location.pathname;

  useEffect(() => {
    if (checkPathMatch('apis', pathName)) {
      const id = pathName.split('/').pop();
      const item = infoApi.find((c) => c.id === id);
      item && loadDefaultSwaggerApi(item);
    }
  }, [infoApi, pathName]);

  useEffect(() => {
    if (!!Object.keys(activeApi).length) {
      updateSwaggerApiVersion(selectedVersion, activeApi);
    }
  }, [selectedVersion])

  return (
    <>
      <div id="menu-section-guides">
        <GuideNavigation location={location} />
      </div>
      <div id="menu-section-apis">
        <Apis location={location} />
      </div>
      <div id="menu-section-sdks">
        <SdkNavigation location={location} />
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CombinedDocsMenu);
